module.exports = __webpack_public_path__ + "img/hviezda3.3f7a5aac.svg";